import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useAuth } from '@shared/auth';
import { Flex } from '@shared/components';
import { useHasPermission } from '@shared/permissions';

import { QSetReviewHistoryItem } from '../../components';
import { useQSetReviewHistory } from '../../providers';
import { getQSetReviewSubtaskDetailsPath } from '../../utils';

export default function QSetReviewHistoryList() {
  const { taskDetails } = useQSetReviewHistory();
  const { userProfile } = useAuth();
  const hasViewPermission = useHasPermission(APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW);

  const userId = userProfile?.id;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      {taskDetails.map((task, index) => {
        return (
          <QSetReviewHistoryItem
            key={`qset-review-history-item-${index}`}
            assignerName={`${task.assignee.firstname} ${task.assignee.lastname}`}
            assignedAt={task.assignedAt}
            taskId={task.id}
            reviewers={task.subtasks.map((subtask) => ({
              id: subtask.id,
              name: `${subtask.assignee.firstname} ${subtask.assignee.lastname}`,
              assignedAt: subtask.assignedAt,
              submittedAt: subtask.updatedAt,
              detailsPath: userId
                ? getQSetReviewSubtaskDetailsPath({
                    userId,
                    subtaskAssigneeId: subtask.assignee.id,
                    subtaskOwnerId: subtask.ownerId,
                    subtaskAssignerId: subtask.assignerId,
                    hasViewTaskManagementPermission: hasViewPermission,
                  })
                : undefined,
            }))}
            taskName={task.name ?? '-'}
          />
        );
      })}
    </Flex>
  );
}
